import { combineReducers } from "redux";
import userStore from "./user.store";
import datasStore from "./datas.store";
export default combineReducers({ userStore, datasStore});